"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.evaluate = exports.tryOrElse = exports.arrayIntRange = exports.nameOf = void 0;
const nameOf = (name) => name;
exports.nameOf = nameOf;
const arrayIntRange = (start, end) => Array.from({ length: end - start + 1 }, (_, k) => k + start);
exports.arrayIntRange = arrayIntRange;
const tryOrElse = (fn, defaultValue) => {
    // eslint-disable-next-line functional/no-try-statements
    try {
        return fn();
    }
    catch (e) {
        return defaultValue();
    }
};
exports.tryOrElse = tryOrElse;
const evaluate = (value) => (value instanceof Function ? value() : value);
exports.evaluate = evaluate;
